import {
  ApiAppNamespaces,
  ApiBackofficeNamespaces,
  IQueuedRequest,
  OneAPIOptions
} from '../../common'
import { AppOrdersApi } from './app'
import { BackofficeOrdersApi } from './backoffice'
import { Queue } from '../../queue'

export class OrdersApp implements ApiAppNamespaces {
  app: AppOrdersApi
  constructor(
    name: string,
    sessionId: string,
    requestsQueue: Queue<IQueuedRequest>,
    options?: OneAPIOptions
  ) {
    this.app = new AppOrdersApi(name, sessionId, requestsQueue, options)
  }

  invalidateAll() {
    this.app.invalidateAll()
  }
}

export class OrdersBackoffice implements ApiBackofficeNamespaces {
  backoffice: BackofficeOrdersApi
  constructor(
    name: string,
    sessionId: string,
    requestsQueue: Queue<IQueuedRequest>,
    options?: OneAPIOptions
  ) {
    this.backoffice = new BackofficeOrdersApi(
      name,
      sessionId,
      requestsQueue,
      options
    )
  }

  invalidateAll() {
    this.backoffice.invalidateAll()
  }
}
